{% block ddms_paypal_ext %}
    <sw-page class="ddms-paypal-ext">
        <template #content>
            <sw-card-view>
                <sw-card :isLoading="isLoading">
                    <sw-container columns="repeat(auto-fit, minmax(250px, 1fr))" gap="0px 30px">
                        <sw-single-select
                                v-model:value="ddmsClient"
                                :options="ddmsClientOptions"
                                label="Profit Center"
                        />

                        <sw-single-select
                                v-model:value="ddmsMode"
                                :options="ddmsModeOptions"
                                label="Modus"
                        />

                        <sw-text-field v-model="ddmsStartDate" label="Startdatum"></sw-text-field>

                        <sw-button-process
                                :isLoading="isLoading"
                                :processSuccess="processSuccess"
                                variant="primary"
                                @process-finish="exportFinish"
                                @click="onClickExport">
                            {{ $tc('ddms-paypal.general.export') }}
                        </sw-button-process>
                    </sw-container>
                </sw-card>
            </sw-card-view>
        </template>
    </sw-page>
{% endblock %}
